import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Tabs } from "@/core/components/ui/tabs";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const ReviewsSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <Stack
      direction="column"
      justify="between"
      align="start"
      className={"flex-none gap-6 bg-bg-secondary/50 p-6"}
    >
      <Stack gap={"xs"}>
        <Skeleton className="h-[12px] w-10"></Skeleton>
        <Skeleton className="h-[20px] w-20"></Skeleton>
      </Stack>
      <Skeleton className="h-[40px] w-full"></Skeleton>
    </Stack>
    <div className="flex-1 overflow-hidden">
      <Stack gap="none" fullWidth className="h-full">
        <Tabs className="flex w-full flex-1 flex-col gap-4 overflow-hidden p-4 px-6">
          <Stack fullWidth gap={"sm"}>
            <Skeleton className="h-[16px] w-16"></Skeleton>
            <Skeleton className="h-[20px] w-40"></Skeleton>
          </Stack>

          <Stack fullWidth gap={"sm"}>
            <Skeleton className="h-[16px] w-16"></Skeleton>
            <Skeleton className="h-[20px] w-40"></Skeleton>
          </Stack>

          <Stack fullWidth gap={"sm"}>
            <Skeleton className="h-[16px] w-16"></Skeleton>
            <Skeleton className="h-[20px] w-40"></Skeleton>
          </Stack>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
